export default __webpack_public_path__ + "static/media/gallery34.8e829097.webp";